// extracted by mini-css-extract-plugin
module.exports = {"block":"TemplateDetailsBlock_block_3Einu","header":"TemplateDetailsBlock_header_1jGTb","content":"TemplateDetailsBlock_content_2oAQg"};